// extracted by mini-css-extract-plugin
export default {"radioLabel":"CheckLabel-radioLabel-Qi2","checked":"CheckLabel-checked-Rgx"};